import BookingForm from './BookingForm';
import { ADDRESS_LINES, BRAND, HOURS } from '@/constants';

const infos = [
  {
    icon: 'ri-map-pin-line',
    title: 'Adresse',
    desc: `${BRAND.name}\n${ADDRESS_LINES.street}, ${ADDRESS_LINES.cityLine}`,
  },
  {
    icon: 'ri-time-line',
    title: 'Horaires',
    desc: HOURS.rows.map((r) => `${r.day} : ${r.hours}`).join('\n'),
  },
  {
    icon: 'ri-phone-line',
    title: 'Contact',
    desc: `${BRAND.phoneDisplay}\n${BRAND.email}`,
  },
];

export default function Appointment() {
  return (
    <section id="rdv" className="py-20 px-6 bg-[#f6f3ec] scroll-mt-[84px]">
      <div className="max-w-[1180px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div>
            <span className="text-[#0b6b52] text-xs font-semibold tracking-widest uppercase mb-3 block">
              Réservation
            </span>
            <h2
              className="text-[clamp(34px,4.4vw,52px)] font-bold leading-[1.12] text-[#173029] mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Prenez votre
              <span className="block text-[#0b6b52] italic">Rendez-vous</span>
            </h2>
            <p className="text-[#57534a] leading-relaxed mb-4">
              Envoyez une demande de créneau en quelques minutes. Nous confirmons par e-mail sous 24h
              (jours ouvrés).
            </p>
            <p className="text-sm text-[#8a8578] mb-8">
              Ce n&apos;est pas une réservation instantanée en ligne : un praticien valide votre demande à
              la main pour coller à vos besoins et à nos disponibilités.
            </p>

            <div className="space-y-3">
              {infos.map((info) => (
                <div
                  key={info.title}
                  className="flex items-start gap-4 bg-white border border-[#e8e2d4] rounded-[14px] p-4"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-[#0b6b52]/10 rounded-xl flex-shrink-0">
                    <i className={`${info.icon} text-[#0b6b52] text-lg`}></i>
                  </div>
                  <div>
                    <div className="text-[#22201c] font-semibold text-sm">{info.title}</div>
                    <div className="text-[#8a8578] text-xs mt-0.5 whitespace-pre-line">{info.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            <p className="mt-6 text-xs text-[#8a8578]">
              Voir les tarifs détaillés dans la section{' '}
              <a href="#tarifs" className="text-[#0b6b52] font-semibold hover:underline">
                Nos Tarifs
              </a>
              . Séance 3 zones (60€) — le plus demandée.
            </p>
          </div>

          <BookingForm />
        </div>
      </div>
    </section>
  );
}
